import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { IFormSubmitButton } from "../../models/formFields";
import {
    FORM_FIELD_HAS_ERRORS_CLASS_NAME,
    FORM_FIELD_HIDDEN_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "../classNames";
import { showValidationErrors } from "../hooks/formUtils";

export const FormSubmit = <FieldName extends string = string>(
    props: IFormSubmitButton<FieldName>,
): React.ReactNode => {
    const {
        hidden = false,
        type = "submit",
        value = "Submit",
        className = "button button--primary-congress-blue",
        id,
        inputRef,
        name,
        disabled,
        onMouseEnter,
        onMouseLeave,
        onSubmit,
    } = props;

    const inputProps = {
        id,
        ref: inputRef,
        name,
        type,
        className,
        value: value === null ? "" : value,
        disabled,
        onMouseEnter,
        onMouseLeave,
        onSubmit,
    };

    const hasErrors = showValidationErrors(props);
    const classes = concatClassNames([
        FORM_FIELD_SUBMIT_CLASS_NAME,
        hidden ? FORM_FIELD_HIDDEN_CLASS_NAME : null,
        hasErrors ? FORM_FIELD_HAS_ERRORS_CLASS_NAME : null,
    ]);

    return (
        <div className={classes}>
            <input {...inputProps} />
        </div>
    );
};
